import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

/**
 * A "panel" card with a header row (title + optional action), a body, and
 * an optional footer. Used for activity feeds, table sections, etc.
 */
export function SectionCard({
  title,
  subtitle,
  icon: Icon,
  action,
  children,
  footer,
  className = "",
  padded = true,
}: {
  title: string;
  subtitle?: string;
  icon?: LucideIcon;
  action?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
  padded?: boolean;
}) {
  return (
    <section className={`card overflow-hidden ${className}`}>
      <header className="flex items-center justify-between gap-3 border-b border-line px-5 py-4">
        <div className="flex items-center gap-3 min-w-0">
          {Icon && (
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-50 text-brand-700">
              <Icon className="h-4 w-4" strokeWidth={2.2} />
            </div>
          )}
          <div className="min-w-0">
            <h3 className="truncate text-sm font-semibold text-ink">{title}</h3>
            {subtitle && <p className="truncate text-xs text-muted">{subtitle}</p>}
          </div>
        </div>
        {action}
      </header>
      <div className={padded ? "p-5" : ""}>{children}</div>
      {footer && <footer className="border-t border-line bg-canvas-deep/40 px-5 py-3">{footer}</footer>}
    </section>
  );
}
